// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { PublicationListResponse } from '@par/app/core/model/dictionaries.response';

export const getPublicationListRequested = createAction('[SELECT PUBLICATION] Get Publication List Requested');
export const getPublicationListSucceeded = createAction('[SELECT PUBLICATION] Get Publication List Succeeded', props<{
  response: PublicationListResponse
}>());
export const getPublicationListFailed = createAction('[SELECT PUBLICATION] Get Publication List Failed');
